import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["applicationId", "locationId", "children", "overrides"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { payments } from '../../node_modules/@square/web-sdk/dist/payments.es.js';
import ErrorScreen from '../../components/error-screen/error-screen.es.js';
import { useDynamicCallback } from '../../hooks/use-dynamic-callback.es.js';
var FormContext = React.createContext({
  cardTokenizeResponseReceived: null,
  createPaymentRequest: null,
  payments: null
});

function FormProvider(_ref) {
  var applicationId = _ref.applicationId,
      locationId = _ref.locationId,
      children = _ref.children,
      overrides = _ref.overrides,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      instance = _React$useState2[0],
      setInstance = _React$useState2[1];

  var _React$useState3 = React.useState(function () {
    var _props$createPaymentR;

    return (_props$createPaymentR = props.createPaymentRequest) === null || _props$createPaymentR === void 0 ? void 0 : _props$createPaymentR.call(props);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 1),
      createPaymentRequest = _React$useState4[0];

  React.useEffect(function () {
    var abortController = new AbortController();
    var signal = abortController.signal;

    function loadPayment(_x) {
      return _loadPayment.apply(this, arguments);
    }

    function _loadPayment() {
      _loadPayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(signal2) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return payments(applicationId, locationId, overrides).then(function (res) {
                  if (res === null) {
                    throw new Error("Square Web Payments SDK failed to load");
                  }

                  if (signal2 !== null && signal2 !== void 0 && signal2.aborted) {
                    return;
                  }

                  setInstance(res);
                  return res;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _loadPayment.apply(this, arguments);
    }

    if (applicationId && locationId) {
      loadPayment(signal);
    }

    return function () {
      abortController.abort();
    };
  }, [applicationId, locationId]);

  var cardTokenizeResponseReceived = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(rest) {
      var verifyBuyerResults;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(rest.errors || !props.createVerificationDetails)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return props.cardTokenizeResponseReceived(rest);

            case 3:
              return _context2.abrupt("return");

            case 4:
              _context2.next = 6;
              return instance === null || instance === void 0 ? void 0 : instance.verifyBuyer(String(rest.token), props.createVerificationDetails());

            case 6:
              verifyBuyerResults = _context2.sent;
              _context2.next = 9;
              return props.cardTokenizeResponseReceived(rest, verifyBuyerResults);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function cardTokenizeResponseReceived(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var cardTokenizeResponseReceivedCallback = useDynamicCallback(cardTokenizeResponseReceived);

  if (!applicationId || !locationId) {
    return /* @__PURE__ */React.createElement(ErrorScreen, null);
  }

  if (!instance) return null;
  var context = {
    cardTokenizeResponseReceived: cardTokenizeResponseReceivedCallback,
    createPaymentRequest: createPaymentRequest,
    payments: instance
  };
  return /* @__PURE__ */React.createElement(FormContext.Provider, {
    value: context
  }, children);
}

var useForm = function useForm() {
  var context = React.useContext(FormContext);

  if (context === void 0) {
    throw new Error("useForm must be used within a FormProvider");
  }

  return context;
};

export { FormContext, FormProvider as default, useForm };